import { Box, Button, Typography } from '@material-ui/core';
import React from 'react';
import './style.css';

interface Props {
  type: 'show' | 'hide';
  entityName: string;
  closeModal: () => void;
  changeStatus: () => void;
}

export const ChangeEntityModalContent = ({
  type,
  entityName,
  closeModal,
  changeStatus,
}: Props) => {
  const data = {
    hide: {
      title: `Are you sure you want to hide ${entityName}?`,
      description: `${entityName} will be completely hide from the checkout page and remove from all subscriptions that selected this charity.`,
    },
    show: {
      title: `Are you sure you want to show ${entityName}?`,
      description: `${entityName} will be completely show on the checkout page and users can select this charity on payments`,
    },
  };
  return (
    <>
      <Box padding='2em'>
        <Box display='flex' justifyContent='center'>
          <Typography
            variant='h4'
            gutterBottom
            style={{ whiteSpace: 'initial', overflow: 'initial' }}
          >
            {data[type].title}
          </Typography>
        </Box>
        <Box display='flex' justifyContent='center' padding='2em'>
          <Typography
            variant='h6'
            className='base-color'
            style={{ whiteSpace: 'initial', overflow: 'initial' }}
          >
            {data[type].description}
          </Typography>
        </Box>
        <Box display='flex' justifyContent='space-evenly'>
          <Button
            className='entity-remove-button delete-entity-modal-buttons'
            onClick={changeStatus}
          >
            Yes
          </Button>
          <Button
            className='entity-cancel-button delete-entity-modal-buttons'
            onClick={closeModal}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </>
  );
};
